import {
    type MeResponseType
} from "./type";
import {
    request
} from "../request";

const Me = async (): Promise<MeResponseType> => {
    return await request<MeResponseType>("/auth/me", {
        method: "GET"
    });
};

export default Me;
